import React, { FC, useMemo } from 'react';
import './App.css';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom';
import { WalletModalProvider, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { TokenFreezer } from './components/TokenFreezer';

// 导入钱包适配器的样式
require('@solana/wallet-adapter-react-ui/styles.css');

const App: FC = () => {
  // 使用mainnet网络
  const network = WalletAdapterNetwork.Mainnet;

  // 使用Helius RPC节点
  const endpoint = 'https://mainnet.helius-rpc.com/?api-key=0bfec0ca-f518-489f-ab5a-d8c62486af72';

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
    ],
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <div className="App">
            <header className="App-header">
              <h1>Solana Token冻结工具</h1>
              <WalletMultiButton />
              <TokenFreezer />
            </header>
          </div>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};

export default App;
